import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import AIService from '../../services/aiService';
import { JournalType } from './journalHelper';
import NewQuestionDialog from './NewQuestionDialog';

const AskButton = (props) => {
    const [disabled, setDisabled] = useState(false);
    const [showNewQuestion, setShowNewQuestion] = useState(false);

    const newQuestion = (name, question) => {
        setDisabled(true);
        AIService.getCompletion(question,
            (data) => { 
                let tempEntry = { 
                    name: name, 
                    note: data, type: 
                    JournalType.NOTE.type, 
                    icon: JournalType.NOTE.icon, 
                    notes: [
                        { role: 'user', content: question },
                        { role: 'assistant', content: data }
                    ]
                };
                props.addEntry(tempEntry);
                setDisabled(false);
            },
            (error) => {
                console.info(error);
                alert('The GM had his mouth full of Cheeteos and his response was unintelligible.');
                setDisabled(false);
            });
    }

    return (
        <React.Fragment>
            <NewQuestionDialog show={showNewQuestion} ask={newQuestion} close={() => setShowNewQuestion(false)} />
            <Button variant="light" onClick={() => setShowNewQuestion(true)} title="New Topic" disabled={disabled}>{disabled ? '🚫' : '❓'}</Button>
        </React.Fragment>
    );
}

export default AskButton;